export default "__VITE_ASSET__LDUHyux7__"